export default "__VITE_PUBLIC_ASSET__dd821d4b__"